module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container section"
  }, [_c('div', {
    staticClass: "row heading"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-6 text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.editEmails
    }
  }, [_vm._v("Create Email")])])]), _vm._v(" "), _vm._l((_vm.carrierEmails), function(email) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-4 col-form-label"
    }, [_c('label', [_vm._v(_vm._s(email.name))])]), _vm._v(" "), _c('div', {
      staticClass: "col-6 email-preview",
      domProps: {
        "innerHTML": _vm._s(email.content)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "col-2 text-right"
    }, [_c('button', {
      staticClass: "btn btn-secondary",
      on: {
        "click": function($event) {
          _vm.editEmails(email)
        }
      }
    }, [_vm._v("Edit Email")])])])
  }), _vm._v(" "), (_vm.showEditEmail) ? _c('modal', {
    attrs: {
      "size": "lg",
      "allow-click-away": "false"
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('h3', [_vm._v("Edit Carrier Email")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-clear close-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelEdit
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  })])]), _vm._v(" "), _c('editor', {
    staticStyle: {
      "width": "600px",
      "margin": "0 auto"
    },
    attrs: {
      "selected": _vm.selected
    },
    on: {
      "saveEmail": _vm.saveEmail
    },
    slot: "body"
  })], 1) : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-6"
  }, [_c('h2', [_vm._v("Carrier Emails")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a950f452!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/carriers/CarrierEmails.vue
// module id = 416
// module chunks = 0